export const DEFAULT_MAX_SECTIONS = 10;
export const DEFAULT_MAX_SECTION_CARD_COUNT = 7;
export const DEFAULT_MIN_SECTION_CARD_COUNT = 7;
export const APP_MIN_SECTION_CARD_COUNT = 4;
export const AGENT_MIN_SECTION_CARD_COUNT = 3;
export const HOME_MIN_SECTION_CARD_COUNT = 4;